import mediumEmphasis from '../../../../text/medium-emphasis';

const dark = (params) => mediumEmphasis(params);

export default dark;
